export default __webpack_public_path__ + "images/21aecd35897d430cc2b06d3b807bf7c9-health.webp";